module.exports = __webpack_public_path__ + "img/file.5f9832d2.svg";